export const env = process.env.NODE_ENV
export const domain = env === 'production' ? 'api2.oval.idnerd.io' : window.location.hostname + ':3088'
export const ssl = env === 'production'
export const autoLogoutTime = 4500